<template>
  <a class="hover:underline" :href="href">{{ title }}</a>
</template>

<script>
export default {
  props: ["href", "title"],
};
</script>
